import { useModals } from 'almanac-ui/Modal'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import {
  SourceMaterialModalV2,
  SourceMaterialModalV2Props,
} from 'screens/BrandKits/components/SourceMaterialModalV2/SourceMaterialModalV2'
import useResponsiveDesign from 'hooks/useResponsiveDesign'

export const useOpenSourceMaterialModal = () => {
  const currentWorkspace = useCurrentWorkspace()
  const { openModal } = useModals()
  const { isMobile } = useResponsiveDesign()

  const openNewSourceMaterialModal = (props?: SourceMaterialModalV2Props, stackProps?: { newStack?: boolean }) => {
    if (!currentWorkspace) return

    if (isMobile) {
      // Leave some time for the click to propagation without being the modal open.
      // If this is not done, the modal will open and a SourceMaterial type will be selected immediately
      // due to the click propagation.
      setTimeout(() => {
        openModal(SourceMaterialModalV2, props, stackProps)
      }, 20)
      return
    }
    openModal(SourceMaterialModalV2, props, stackProps)
  }

  return openNewSourceMaterialModal
}
